<template>
  <div class="product-list-container">
    <div class="header">
      <div class="custom-row row w-75">
        <div class="col col-lg-4 col-md-5 col-xs-12">
          <search-input placeholder="Search for Campaign" v-model="search" class="search-input" />
        </div>
      </div>
      <primary-button
        @click.native="$router.push({name: 'company-admin-campaings-add-campaing'})"
        class="primary-button"
      >Add Campaign</primary-button>
    </div>
    <loader :loading="loading" v-if="loading" />
    <template v-if="!loading">
      <div class="table_div" style="width:100%;overflow-x:auto;overflow-y:hidden">
        <table class="Invoice_table" style="margin-top: 50px" v-if="CampaignList.length > 0">
          <thead>
            <tr class="Invoice_table_header">
              <th></th>
              <th>Campaign Name</th>
              <th>Status</th>
              <th>Created On</th>
              <th>Total</th>
              <th>Messages</th>
              <th>Sent</th>
              <th>Suppressed</th>
              <th>Error</th>
              <th>Cost</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr
              class="line"
              v-for="(campaign, k) in CampaignList"
              :key="k"
              :class="{'inactive': campaign.status === 'stop'}"
            >
              <th
                class="status"
                :class="{'running': campaign.status === 'run', 'hold': campaign.status === 'hold', 'stop': campaign.status === 'stop'}"
              ></th>
              <th>{{campaign.campaign_name}}</th>
              <th>{{campaign.status === 'run' ? 'Running' : 'Idle' }}</th>
              <th>{{timeType(campaign.last_start_time)}}</th>
              <th>{{campaign.total_count}}</th>
              <th>{{campaign.messages_count}}</th>
              <th>{{campaign.sent_count}}</th>
              <th>{{campaign.suppressed_count}}</th>
              <th>{{campaign.error_count}}</th>
              <th>{{campaign.total_cost}}</th>
              <th>
                <div class="edit-container">
                  <svg
                    v-show="campaign.status === 'run'"
                    @click="HoldCapaign(campaign.campaign_uuid)"
                    class="icon hold"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path
                      d="M9 16h2V8H9v8zm3-14C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm1-4h2V8h-2v8z"
                    />
                  </svg>
                  <svg
                    v-show="campaign.status === 'run'"
                    @click="StopCapaign(campaign.campaign_uuid)"
                    class="icon stop"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path d="M6 6h12v12H6z" />
                  </svg>
                  <svg
                    @click="RunCapaign(campaign.campaign_uuid)"
                    v-show="campaign.status === 'hold'"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    class="icon running"
                    viewBox="0 0 24 24"
                  >
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path
                      d="M10 16.5l6-4.5-6-4.5v9zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
                    />
                  </svg>
                  <p v-if="campaign.status === 'hold'">run</p>
                  <p class="hold" v-if="campaign.status === 'run'">hold</p>
                  <p class="stop" v-if="campaign.status === 'run'">stop</p>
                </div>
                <div class="icon">
                  <a href>History</a>
                  <svg
                    @click="$router.push({name: 'company-admin-campaings-edit-campaing', params: {id: campaign.campaign_uuid}})"
                    class="svg-grey"
                    width="30px"
                    height="30px"
                    viewBox="0 0 30 30"
                    version="1.1"
                  >
                    <path
                      d="M21.0636684,5 L16.5223005,5 C16.0222902,5 15.6155648,5.41380074 15.6155648,5.92250923 L15.6155648,19.7548339 C15.6155648,20.0601476 15.7303938,20.4698893 15.8885285,20.7291513 L18.1395544,24.4204428 C18.2910881,24.6688561 18.5293057,24.8114391 18.793057,24.8114391 C19.0568083,24.8114391 19.2949534,24.6688561 19.4465596,24.420369 L21.6974404,20.7292251 C21.8556477,20.4698155 21.9704767,20.0601476 21.9704767,19.7548339 L21.9704767,5.92250923 C21.9704041,5.41380074 21.5636062,5 21.0636684,5 Z M19.1930363,22.7361624 L18.3929326,22.7361624 L17.1373575,20.6773432 L20.4485389,20.6773432 L19.1930363,22.7361624 Z M16.7035751,19.5703321 L16.7035751,8.61188192 L18.2488705,8.61188192 L18.2488705,19.5703321 L16.7035751,19.5703321 Z M19.3370259,19.5703321 L19.3370259,8.61188192 L20.8823212,8.61188192 L20.8823212,19.5703321 L19.3370259,19.5703321 Z M20.8823212,6.10701107 L20.8823212,7.50487085 L16.7036477,7.50487085 L16.7036477,6.10701107 L20.8823212,6.10701107 Z M16.4717409,23.8886347 C16.7721969,23.8886347 17.0157824,24.1364576 17.0157824,24.4421402 C17.0157824,24.7478229 16.7721969,24.9956458 16.4717409,24.9956458 L8.56943005,24.9956458 C8.26897409,24.9956458 8.0253886,24.7478229 8.0253886,24.4421402 C8.0253886,24.1363838 8.26897409,23.8886347 8.56943005,23.8886347 L16.4717409,23.8886347 Z"
                      id="path-1"
                    />
                  </svg>
                  <svg
                    @click="showAlert(campaign.campaign_uuid)"
                    class="svg-grey delete"
                    width="30px"
                    height="30px"
                    viewBox="0 0 30 30"
                    version="1.1"
                  >
                    <path
                      d="M22.0359259,7.63839416 L18.7919259,7.63839416 L18.7919259,6.35036496 C18.7919259,5.60576642 18.1771852,5 17.4215556,5 L12.5477037,5 C11.7920741,5 11.1773333,5.60576642 11.1773333,6.35036496 L11.1773333,7.63839416 L7.93333333,7.63839416 C7.42274074,7.63839416 7.00740741,8.04766423 7.00740741,8.55080292 L7.00740741,10.2229927 C7.00740741,10.7261314 7.42274074,11.1354015 7.93333333,11.1354015 L8.47111111,11.1354015 L8.47111111,23.6922628 C8.47111111,24.3966423 9.05266667,24.969635 9.76740741,24.969635 L20.2017778,24.969635 C20.9165185,24.969635 21.4980741,24.3966423 21.4980741,23.6922628 L21.4980741,11.1354745 L22.0359259,11.1354745 C22.5465185,11.1354745 22.9618519,10.7262044 22.9618519,10.2230657 L22.9618519,8.55080292 C22.9618519,8.04773723 22.5464444,7.63839416 22.0359259,7.63839416 Z M12.2884444,6.35036496 C12.2884444,6.21189781 12.4071852,6.09489051 12.5477037,6.09489051 L17.4215556,6.09489051 C17.5620741,6.09489051 17.6808148,6.21189781 17.6808148,6.35036496 L17.6808148,7.63839416 L12.2884444,7.63839416 L12.2884444,6.35036496 Z M20.386963,23.6923358 C20.386963,23.7912409 20.3021481,23.8748175 20.2017778,23.8748175 L9.76740741,23.8748175 C9.66703704,23.8748175 9.58222222,23.7912409 9.58222222,23.6923358 L9.58222222,11.1354745 L20.386963,11.1354745 L20.386963,23.6923358 Z M21.8507407,10.0405839 L8.11851852,10.0405839 L8.11851852,8.73328467 L21.8507407,8.73328467 L21.8507407,10.0405839 Z M11.7328889,22.3270073 C11.426,22.3270073 11.1773333,22.0818978 11.1773333,21.779562 L11.1773333,13.4284672 C11.1773333,13.1261314 11.426,12.8810219 11.7328889,12.8810219 C12.0397037,12.8810219 12.2884444,13.1261314 12.2884444,13.4284672 L12.2884444,21.779562 C12.2884444,22.0818978 12.0397037,22.3270073 11.7328889,22.3270073 Z M14.9846667,22.3270073 C14.6778519,22.3270073 14.4291111,22.0818978 14.4291111,21.779562 L14.4291111,13.4284672 C14.4291111,13.1261314 14.6777778,12.8810219 14.9846667,12.8810219 C15.2915556,12.8810219 15.5402222,13.1261314 15.5402222,13.4284672 L15.5402222,21.779562 C15.5402222,22.0818978 15.2915556,22.3270073 14.9846667,22.3270073 Z M18.2363704,22.3270073 C17.9294815,22.3270073 17.6808148,22.0818978 17.6808148,21.779562 L17.6808148,13.4284672 C17.6808148,13.1261314 17.9294815,12.8810219 18.2363704,12.8810219 C18.5432593,12.8810219 18.7919259,13.1261314 18.7919259,13.4284672 L18.7919259,21.779562 C18.7919259,22.0818978 18.5432593,22.3270073 18.2363704,22.3270073 Z"
                      id="path-1"
                    />
                  </svg>
                </div>
              </th>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col col-lg-6 col-md-7 col-xs-12 per-page">
        <span class="filter_by">Show Per Page:</span>
        <div class="primary-input-container choose-type perPage">
          <primary-select
            type="text"
            @input="changePerPage"
            v-model="per_page" :is-cross="false"
            class="choose-type perPage"
            placeholder="Select"
          >
            <option :value="item" v-for="(item,key) in pages" :key="key">{{item}}</option>
          </primary-select>
        </div>
      </div>
      <pagination-component
        @change-page="changePage($event)"
        :page="Page"
        :perPage="per_page"
        :total="TotalPages"
        :qnt="CampaignList.length"
      />
    </template>
  </div>
</template>

<script>
import { format } from "date-fns";

export default {
  components: {
    SearchInput: () => import("@/components/Inputs/SearchInput.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    CardComponent: () => import("@/components/CardComponent.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    PaginationComponent: () => import("@/components/Pagination.vue"),
    Loader: () => import("@/components/Loader.vue"),
  },
  data: () => ({
    CampaignList: [],
    Page: 0,
    search: "",
    TotalPages: null,
    path: null,
    pages: [10, 20, 50, 100, 200],
    per_page: 10,
    loading: true,
  }),
  mounted() {
    console.log("this.$store.state", this.$store.state);
    this.path = `http://88.198.219.62/api_smsc/v1/file/${this.$store.state.company.company.contact.logo_file_uuid}`;
  },
  created() {
    this.GetList();
  },
  watch: {
    search() {
      this.Page = 0;
      this.GetList();
    },
  },
  methods: {
    timeType(time) {
      return format(time, "D MMM YYYY");
    },
    changePage(page) {
      this.Page = page;
      this.GetList();
    },
    changePerPage(e) {
      this.GetList();
    },
    GetList() {
      this.loading = true;
      this.$store
        .dispatch("GetCampaignList", {
          page: this.Page,
          per_page: this.per_page ? this.per_page : 10,
          campaign_name: this.search,
        })
        .then((res) => {
          console.log("resssssssss", res);
          this.Page = res.page;
          this.TotalPages = res.total / res.per_page;
          this.CampaignList = res.items;
          this.loading = false;
        });
    },
    RunCapaign(campaign_uuid) {
      this.$store
        .dispatch("RunCapaign", campaign_uuid)
        .then(() => {
          this.GetList();
          this.$snotify.success("Campaign is running");
        })
        .catch((err) => {
          this.$snotify.error(err.response.statusText);
        });
    },
    StopCapaign(campaign_uuid) {
      this.$store
        .dispatch("StopCapaign", campaign_uuid)
        .then(() => {
          this.GetList();
          this.$snotify.success("Campaign has stopped");
        })
        .catch((err) => {
          this.$snotify.error(err.response.statusText);
        });
    },
    HoldCapaign(campaign_uuid) {
      this.$store
        .dispatch("HoldCapaign", campaign_uuid)
        .then(() => {
          this.GetList();
          this.$snotify.success("Campaign has hold");
        })
        .catch((err) => {
          this.$snotify.error(err.response.statusText);
        });
    },
    showAlert(campaign_uuid) {
      // Use sweetalert2
      this.$swal({
        title: "Are you sure?",
        text: "You will not be able to recover this campaign!",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, keep it",
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("DeleteCampaign", campaign_uuid)
            .then(() => {
              this.GetList();
              this.$swal(
                "Deleted!",
                "Your campaign has been deleted.",
                "success"
              );
            })
            .catch((err) => {
              this.$snotify.error(err.response.statusText);
            });

          // For more information about handling dismissals please visit
          // https://sweetalert2.github.io/#handling-dismissals
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.product-list-container {
  .per-page {
    display: flex;
    margin-top: 20px;

    span {
      display: inline-block;
      margin-top: 7px;
      margin-right: 10px;
      /*width: 140px;*/
    }
  }
  .perPage {
    width: 120px;
  }
  .custom-row {
    width: 100%;
    display: flex;
  }
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    margin: 20px 0;
    .search-input {
      max-width: 345px;
      height: 100%;
      background-color: #ffffff;
    }
    .primary-button {
      height: 40px;
      width: 150px;
    }
  }

  table.Invoice_table {
    width: 99%;
    //   tbody tr:nth-of-type(odd) {
    //     background-color: rgba(0, 0, 0, 0.05);
    // }
  }
  table thead tr {
    background: linear-gradient(135deg, #51a3f3 0%, #51b5f3 100%);
    th {
      border-bottom-width: 2px;
      color: white;
      padding-left: 10px;
      vertical-align: bottom;
      border-bottom: 2px solid #dee2e6;
      border: 1px solid #dee2e6;
    }
  }
  table,
  tr {
    width: 100%;
    box-shadow: inset 0 -1px 0 0 #f0f1fa;
    -webkit-box-shadow: inset 0 -1px 0 0 #f0f1fa;
    -moz-box-shadow: inset 0 -1px 0 0 #f0f1fa;
    background-color: #ffffff;
  }

  table {
    border-collapse: collapse;
  }
  .Invoice_table_popup {
    width: 75px;
  }
  .Invoice_table_header th {
    color: white;
    padding-left: 10px;
    border-bottom-width: 2px;
    vertical-align: bottom;
    border-bottom: 2px solid #dee2e6;
    border: 1px solid #dee2e6;
    padding: 0.75rem;
    text-align: center;
  }
  .Invoice_table_header th:first-child {
    padding-left: 20px;
    padding-right: 30px;
    width: 14%;
  }
  tbody th:first-child {
    padding-left: 20px;
    padding-right: 30px;
  }
  .popup_content {
    display: none;
  }
  .popup_cta {
    cursor: pointer;
    padding-right: 5px;
  }
  .Invoice_table_popup {
    text-align: right;
    position: relative;
  }
  tbody th {
    height: 40px;
    color: #212b36;
    font-weight: normal;
    font-family: "Helvetica Neue";
    font-size: 14px;
    line-height: 20px;
    padding: 8px 20px;
  }
}
@media (max-width: 1500px) {
  .product-list-container .table-header[data-v-791ec093] {
    width: 1161px;
  }
  .product-list-container .table-body.inactive[data-v-791ec093] {
    width: 1161px;
  }
}
.table_div::-webkit-scrollbar {
  // width: 5px;
  width: 8px;
  height: 8px;
  background-color: #f5f5f5;
}

.table_div::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-image: -webkit-gradient(
    linear,
    left bottom,
    left top,
    color-stop(0.44, #51a3f3),
    color-stop(0.72, #51a3f3),
    color-stop(0.86, #51a3f3)
  );
}
</style>

